import React, { useMemo } from 'react';
import { IconBooks, IconUpload } from '@tabler/icons-react';

import { useUser } from '../../hooks/useUser';
import Sidebar from './Sidebar';
import { ModuleLink } from './SidebarItem';

const moduleLinks: ModuleLink[] = [
    {
        label: 'Materials',
        icon: IconBooks,
        path: 'materials',
    },
    {
        label: 'Upload',
        icon: IconUpload,
        path: 'upload',
    },
];

function TrainingSidebar() {
    const { isSuperAdmin } = useUser();

    const filteredLinks = useMemo(
        () =>
            moduleLinks.filter(link => {
                if (link.label === 'Upload') {
                    return isSuperAdmin;
                }
                return true;
            }),
        [isSuperAdmin],
    );

    return <Sidebar moduleLinks={filteredLinks} pathPrefix="/training/" />;
}

export default TrainingSidebar;
